import styled from 'styled-components'
import { Box } from 'grommet'

export const CalloutWrapper = styled(Box).attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))``
